<template>
  <div>
    <progress-bar />
    <confirm-modal />
    <div class="main-wrapper container-fluid">
    <app-header
      v-if="user"
      :user="user"
      :true-user="trueUser"
      :simulating="simulating"
      :session-links="sessionLinks"
      :permissions="permissions"
      :locale="locale"
    />
    <guest-header
      v-else-if="initialized"
      :locale="locale"
    />

    <div id="body">
      <flash-messages :messages="flashMessages" @dismiss="dismissFlash" />

      <div class="main">
        <div class="row">
          <router-view
            v-if="initialized"
            :key="$route.fullPath"
          />

          <div v-else class="col-xs-12 loading text-center">
            <span class="glyphicon glyphicon-refresh spinning" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </div>

    <app-footer />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/layouts/app_header.vue'
import AppFooter from '@/layouts/app_footer.vue'
import FlashMessages from '@/layouts/flash_messages.vue'
import GuestHeader from '@/layouts/guest_header.vue'
import ProgressBar from '@/components/progress_bar.vue'
import ConfirmModal from '@/components/confirm_modal.vue'

// Global store modules
import store from '@/store.js'
import flashModule from '@/stores/flash.js'
import progressModule from '@/stores/progress.js'
import confirmModule from '@/stores/confirm.js'
import appModule from '@/stores/app.js'
import projectModule from '@/stores/project.js'

// Register global stores
if (!store.hasModule('flash')) store.registerModule('flash', flashModule)
if (!store.hasModule('progress')) store.registerModule('progress', progressModule)
if (!store.hasModule('confirm')) store.registerModule('confirm', confirmModule)
if (!store.hasModule('app')) store.registerModule('app', appModule)
if (!store.hasModule('project')) store.registerModule('project', projectModule)

export default {
  name: 'app-layout',

  computed: {
    user() {
      return this.$store.state.app.user
    },

    trueUser() {
      return this.$store.state.app.true_user
    },

    simulating() {
      return this.$store.state.app.simulating
    },

    sessionLinks() {
      return this.$store.state.app.links
    },

    permissions() {
      return this.$store.state.app.permissions
    },

    locale() {
      return this.$store.state.app.locale
    },

    initialized() {
      return this.$store.state.app.initialized
    },

    flashMessages() {
      return this.$store.state.flash.messages
    }
  },

  mounted() {
    // Fetch session if not initialized
    if (!this.initialized) {
      this.$store.dispatch('app/fetchSession')
    }
  },

  methods: {
    dismissFlash(index) {
      this.$store.commit('flash/remove', index)
    }
  },

  components: {
    AppHeader,
    AppFooter,
    FlashMessages,
    GuestHeader,
    ProgressBar,
    ConfirmModal
  }
}
</script>
